<template lang="pug">
    .image-wrapper
        .image(v-for="image in images" :key="image.id" )
            AlbumImage( :content="image" )
</template>
<script>
//import Components
import AlbumImage from "./Image.vue";

export default {
  name: "Photalbum",
  components: {
    AlbumImage
  },
  data() {
    return {
      containerWidth: undefined
    };
  },
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  computed: {
    contents() {
      return this.section.contents || [];
    },
    images() {
      return this.contents.filter(content => content.key === "image");
    }
  },
  methods: {}
};
</script>
<style lang="sass" scoped>
.image-wrapper
    @apply flex justify-center
    .image
        width: calc(25% - 30px)
        padding: 0 15px
</style>
